var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-header',{attrs:{"title":_vm.headerTitle,"theme":_vm.theme}},[_c('template',{slot:"right"},[_vm._t("header-right")],2)],2),_c('v-main',[_c('router-view',_vm._g({},_vm.$listeners)),_vm._t("default"),_vm._t("map")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }